import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import numeral from 'numeral';
import moment from 'moment';

export const generateDynamicPDF = ({
  orientation = 'landscape',
  filename = 'Report.pdf',
  headers = [],
  columns = [],
  rows = [],
  rowsRaw = [],
  totalFields = [],
  currencyFields = [],
  totalFieldIndexes = {},
  totalLabel = 'Total:',
  totalLabelIndex = 7,
  rightAlignIndexes = [],
  asOnDate = null,
  margin = { top: 3, left: 3, right: 3, bottom: 3 }
}) => {
  const doc = new jsPDF({ orientation });

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(7);

  let xPos = margin.left;
  let yPos = margin.top;

  // ✏️ Draw headers
  headers.forEach(({ label, value }) => {
    if (value) {
      const text = `${label}: ${value}`;
      doc.text(text, xPos, yPos);
      xPos += doc.getTextWidth(text) + 10;
    }
  });

  // ✏️ Draw "Pending Till" if present
  if (asOnDate) {
    const pendingDate = moment(asOnDate).format("MM-DD-YYYY");
    const text = `Pending Till: ${pendingDate}`;
    doc.text(text, xPos, yPos);
  }

  // ⬇️ Calculate space below headers
  const tableStartY = yPos + 5;

  // 🔢 Totals
  let totals = {};
  if (totalFields.length && rowsRaw.length) {
    totals = rowsRaw.reduce((acc, item) => {
      totalFields.forEach(field => {
        acc[field] = (acc[field] || 0) + (parseFloat(item[field]) || 0);
      });
      return acc;
    }, {});
  }

  let totalRow = null;
  if (Object.keys(totals).length) {
    totalRow = Array(columns.length).fill('');
    totalRow[totalLabelIndex] = totalLabel;

    totalFields.forEach(field => {
      const val = totals[field];
      const colIndex = totalFieldIndexes?.[field];
      if (colIndex !== undefined) {
        totalRow[colIndex] = currencyFields.includes(field)
          ? "$" + numeral(val).format("0,00.00")
          : numeral(val).format("0,0");
      }
    });
  }

  // 🧾 Render Table
  doc.autoTable({
    head: [columns],
    body: rows,
    ...(totalRow && { foot: [totalRow] }),
    styles: {
      fontSize: 4.5,
      halign: 'left',
      lineWidth: 0.1,
      lineColor: [180, 180, 180]
    },
    headStyles: {
      fillColor: [224, 230, 237],
      textColor: [0, 0, 0],
      fontStyle: 'bold',
      halign: 'center',
      valign: 'middle',
      fontSize: 6.5
    },
    bodyStyles: {
      textColor: [0, 0, 0],
      fillColor: [255, 255, 255]
    },
    footStyles: {
      fontStyle: 'bold',
      fontSize: 5.5,
      fillColor: [255, 255, 255],
      textColor: [0, 0, 0],
      halign: 'right',
      lineWidth: 0.1,
      lineColor: [180, 180, 180]
    },
    margin: {
      ...margin,
      top: tableStartY
    },
    columnStyles: Object.fromEntries(
      rightAlignIndexes.map(i => [i, { halign: 'right' }])
    ),
    didParseCell: function (data) {
      if (data.section === 'head') {
        data.cell.styles.halign = rightAlignIndexes.includes(data.column.index) ? 'right' : 'left';
      }
      if (data.section === 'body') {
        data.cell.styles.fillColor = [255, 255, 255];
      }
    }
  });

  doc.save(filename);
};
